/**
 * @generated SignedSource<<4a8edf34aed6d4298302c4e8ecb905b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUUpdateCategoryInput = {
  setColor?: string | null;
  setFilterTeamIds?: ReadonlyArray<string> | null;
  setTitle?: string | null;
};
export type PLUCategoryEditMutation$variables = {
  id: string;
  input: PLUUpdateCategoryInput;
};
export type PLUCategoryEditMutation$data = {
  readonly pluCategory: {
    readonly update: {
      readonly color: string;
      readonly id: string;
      readonly teamsFilter: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly title: string;
    } | null;
  } | null;
};
export type PLUCategoryEditMutation = {
  response: PLUCategoryEditMutation$data;
  variables: PLUCategoryEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PLUCategoryMutation",
    "kind": "LinkedField",
    "name": "pluCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teamsFilter",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategoryEditMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUCategoryEditMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f00d5d9c1217966c6f1ddd6a035c81e3",
    "id": null,
    "metadata": {},
    "name": "PLUCategoryEditMutation",
    "operationKind": "mutation",
    "text": "mutation PLUCategoryEditMutation(\n  $id: ID!\n  $input: PLUUpdateCategoryInput!\n) {\n  pluCategory(id: $id) {\n    update(input: $input) {\n      id\n      title\n      color\n      teamsFilter {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "108ae28f97983b3b592cedbcc8328c0d";

export default node;
